module.exports = __webpack_public_path__ + "img/index-section6-friend6_a.4c51ee45.svg";